import { ILocationState, Redirect, Route } from '@framework/ui';
import React, { useMemo } from 'react';
import { Switch, useLocation } from 'react-router';
import { NotFoundPage } from '../errors/not-found/NotFoundPage';
import { ThemeLogic } from '../theme/ThemeLogic';
import { ForgotPasswordPage } from './login/ForgotPasswordPage';
import { RegistrationPage } from './login/RegistrationPage';
import { UserActivationPage } from './UserActivationPage';
import { UserChangePasswordPage } from './UserChangePasswordPage';
import { UserEmailValidationPage } from './UserEmailValidationPage';
import { UserProfilePage } from './UserProfilePage';
import { UserResetPasswordPage } from './UserResetPasswordPage';

export interface IExtendedUserLoginRoutesProps {
  isLogged: boolean;
}

/**
 * Routes estese per il login utente, con la gestione SPID/CIE/eIDAS, registrazione, reimposta password, profilo
 * utente, attivazione, login dipendenti, etc...
 */
export default function ExtendedUserLoginRoutes(
  props: IExtendedUserLoginRoutesProps,
) {
  const { isLogged } = props;

  const location = useLocation<ILocationState>();

  const allowExtendedUserLoginRoutes = useMemo(
    () => ThemeLogic.allowExtendedUserLoginRoutes(),
    [],
  );

  if (!allowExtendedUserLoginRoutes) return null;

  if (!isLogged) {
    return (
      <Switch>
        <Route path="/utente/registrazione" component={RegistrationPage} />
        <Route
          path="/utente/recupera-password"
          component={ForgotPasswordPage}
        />
        <Route path="/utente/attivazione" component={UserActivationPage} />
        <Route
          path="/utente/reimposta-password"
          component={UserResetPasswordPage}
        />
        <Redirect
          to={{
            pathname: '/login',
            state: { ...(location.state ?? {}), from: location },
          }}
        />
      </Switch>
    );
  }

  return (
    <Switch>
      <Redirect exact from="/utente/attivazione" to="/" />
      <Route path="/utente/profilo" component={UserProfilePage} />
      <Route
        path="/utente/completa-profilo"
        component={UserEmailValidationPage}
      />
      <Route
        path="/utente/cambia-password"
        component={UserChangePasswordPage}
      />
      {/** Pagina non trovata */}
      <Route component={NotFoundPage} />
    </Switch>
  );
}
